var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tn",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M124 0h496v496H124z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-128) scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M0 0h744v496H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M497.8 247.8a125.1 125.1 0 1 1-250.2 0 125.1 125.1 0 0 1 250.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M372.7 330.8a83 83 0 0 1-83-83 83 83 0 0 1 83-83c11.4 0 24.5 2.7 33.3 9.2-60.6 2.3-76 53.7-76 74.5s9.8 67 76 73.8a70.4 70.4 0 0 1-33.3 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M445.8 282.7 408.1 269l-24.9 31.4 1.4-40-37.6-14 38.6-11.1 1.7-40 22.4 33.2 38.6-10.8-24.7 31.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/tn.7d4a529d618922608c0cb1807e5d83cc.svg";
export { ForwardRef as ReactComponent };